// Vendors
import React from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

// Components
import { Trans, FormActions, FormActionsItem } from '../../../components';
import { TxButton, TxButtonMode } from 'texkit-ui';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';
import SummaryCard from 'texkit/dist/components/Cards/SummaryCard/SummaryCard';

// Helpers
import { toSentenceCase } from '../../../lib/helpers';

const TXHHSAlreadyLinkedSummary = (account) => {
  const dispatch = useDispatch();

  const items = ["chipCase", "caseNumber"].map((identifier, idx) => {
                    const value = account[identifier];
                    if (!value) return null;
                    return {
                     className: 'word-break',
                     label: <Trans file="Labels" id={`txhhs_${identifier}`} />,
                     value: value || 'N/A',
   }});

  return (
    <>
      <h1 className="h2">
        <Trans
          file="txhhs"
          id="txhhschip_LinkService_ConfirmTitleLinked"
        />
      </h1>
      <p>
        <Trans
          file="txhhs"
          id="txhhschip_LinkService_ConfirmDescriptionLinked"
        />
      </p>
        <SummaryCard>
          <SummaryCard.List
            items={items}
          />
        </SummaryCard>
      <FormActions>
        <FormActionsItem>
          <ButtonPrimary onClick={() => dispatch(push(`/agency/txhhs`))}>
            <Trans
              file="txhhs"
              id="txhhschip_ViewItem"
            />
          </ButtonPrimary>
        </FormActionsItem>
        <FormActionsItem>
          <TxButton
            mode={TxButtonMode.Secondary}
            onClick={() => dispatch(push(`/link/lookup/txhhschip`))}
          >
            <Trans file="txhhs" id={`txhhschip_LinkDifferent`} />
          </TxButton>
        </FormActionsItem>
      </FormActions>
    </>
  );
};

TXHHSAlreadyLinkedSummary.propTypes = {
   account: PropTypes.object.isRequired
};

export default TXHHSAlreadyLinkedSummary;
